"use client";
import type { IModuleHeadline, IModuleHeadlineFields } from "@contentful-api/types/contentful";
import { ModulesRenderer } from "@lib/contentful/modules-renderer/ModulesRenderer";
import dynamic from "next/dynamic";
import { useGlobalContent } from "@app/[locale]/GlobalContentProvider";

const Headline = dynamic(() =>
    import("@components/cms/headline/Headline").then((mod) => mod.Headline)
);

export const EditorialLayout = ({ page }) => {
    const { siteSettings } = useGlobalContent();
    const {
        fields: {
            modules,
            title,
            titleSize = "Extra Large",
            desc,
            descriptionSize = "Normal",
            callToActions,
        } = {},
    } = page;
    const { fields: { authorizationInvitation } = {} } = siteSettings;

    return (
        <>
            {(title || desc) && (
                <Headline
                    module={
                        {
                            fields: {
                                title,
                                desc,
                                callToActions,
                                // We need to cast because the types are not exactly the same
                                titleSize: titleSize as IModuleHeadlineFields["titleSize"],
                                descriptionSize,
                            },
                        } as IModuleHeadline
                    }
                    isModule={false}
                />
            )}
            <ModulesRenderer modules={modules} authorizationInvitation={authorizationInvitation} />
        </>
    );
};
